/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h, g as getElement } from './index-ef0fa435.js';

const listHeaderCss = "slot-fb[hidden],slot[hidden]{display:initial !important}:host{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;padding:var(--lar-list-item-padding-top, 0.5rem) var(--lar-list-item-padding-right, 0.5rem) var(--lar-list-item-padding-bottom, 0.5rem) var(--lar-list-item-padding-left, 0.5rem);display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-direction:row;flex-direction:row}.item-inner{-ms-flex:2;flex:2;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:100%;width:100%;font-size:0.9rem;font-weight:500;letter-spacing:1px;text-transform:uppercase;color:var(--lar-text-color-step-150, #d9d9d9)}:host(:empty){display:none !important}";

const ListHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return [
      h("slot", { name: "start" }),
      h("div", { class: "item-inner" }, h("slot", null)),
      h("slot", { name: "end" })
    ];
  }
  get el() { return getElement(this); }
};
ListHeader.style = listHeaderCss;

export { ListHeader as lar_list_header };

//# sourceMappingURL=lar-list-header.entry.js.map